<template>
    <div id="partslist-line-page">
        <pre class="debug" v-if="isDebug">{{ grouped }}</pre>

        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="
                    () =>
                        $router.push(
                            '/partslistview/' +
                                productIdParam +
                                '/' +
                                partslistIdParam
                        )
                "
                icon="arrow-left"
                :label="trans('pages.partslist_line.back_to_partslist')" />
            <actions-menu-item
                :v4="true"
                :action="
                    () =>
                        $router.push(
                            '/partslisteditline/' +
                                productIdParam +
                                '/' +
                                partslistIdParam +
                                '/' +
                                partslistLineIdParam
                        )
                "
                icon="pencil"
                :label="trans('pages.partslist_line.edit')" />
        </actions-menu>

        <div class="leftcolumn">
            <div class="productdefaultfields" v-if="record">
                <div class="productpagefield">
                    <div id="productsawdetailscode">
                        {{ trans('pages.partslist_line.profile') }}: {{ record.code }}
                    </div>
                </div>
                <div class="productpagefield">
                    <div id="productsawdetailslength">
                        {{ trans('pages.partslist_line.length') }}: {{ record.length }}mm
                    </div>
                </div>
                <div class="productpagefield">
                    <div id="productsawdetailscount">
                        {{ trans('pages.partslist_line.count') }}: {{ record.count }}
                    </div>
                </div>
                <p id="productsawdetailsnote">
                    {{ trans('pages.partslist_line.description') }}: {{ record.description }}
                </p>
            </div>

            <div id="productsawfields">
                <template v-for="group in grouped">
                    <template v-for="firstField in group.slice(0, 1)">
                        <div
                            :id="'sawgroup' + firstField.groupId"
                            class="prodSawGroup">
                            <div class="prodSawTitle">
                                {{ firstField.title }}
                            </div>
                            <template v-for="(field, index) in group">
                                <div
                                    :style="{ color: field.hexColor }"
                                    class="prodSawField">
                                    <img
                                        :src="field.imageSrc"
                                        class="product-saw-image"
                                        :id="'profilepageimage-' + field.ID" />
                                    <span class="productsawname">
                                        {{ field.name }} - {{ field.productNr }}
                                    </span>
                                    <span class="productsawvalue">
                                        {{ field.value }}
                                    </span>
                                </div>
                            </template>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import Loader from '../components/loader/Loader';
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import sawlistApi from '../api/sawlist';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [
        IsDebugMixin,
        IdParamMixin(
            'productIdParam',
            'partslistIdParam',
            'partslistLineIdParam'
        ),
        localization,
    ],
    components: {
        Loader,
        ActionsMenu,
        ActionsMenuItem,
    },
    computed: {
        Config: () => Config,
        productIdParam() {
            return this.$route.params.productId;
        },
        partslistIdParam() {
            return this.$route.params.partslistId;
        },
        partslistLineIdParam() {
            return this.$route.params.partslistLineId;
        },
        grouped() {
            const grouped = {};
            if (this.record && this.record.sawlist) {
                this.record.sawlist.forEach((field) => {
                    if (!grouped[field.groupId]) {
                        grouped[field.groupId] = [];
                    }
                    const group = grouped[field.groupId];
                    group.push(field);
                });
            }
            return grouped;
        },
    },
    data() {
        return {
            record: null,
        };
    },
    methods: {
        load() {
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.partslist_line.page_title', {
                    lineId: this.partslistLineIdParam,
                    partslistId: this.partslistIdParam
                }),
                { root: true }
            );

            sawlistApi
                .fetchSawlinesForPartslistRecord(this.partslistLineIdParam)
                .then((response) => {
                    const record = response.data.data;
                    if (!record.paintlistId) {
                        return showErrorMessage(this.trans('pages.partslist_line.error_partslist_line_not_exist'));
                    }
                    record.sawlist.forEach((field) => {
                        field.imageSrc =
                            Config.url +
                            '/profile/fetchImage/?profileId=' +
                            field.profile +
                            '&random=' +
                            Math.random();
                    });
                    this.record = record;
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.partslist_line.error_load_partslist_line'));
                });
        },
    },
};
</script>
